import { useEffect, useState } from 'react';
import { About } from './components/About';
import { BackgroundEffects } from './components/BackgroundEffects';
import { Checkout } from './components/Checkout';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { OrderForm } from './components/OrderForm';
import { Projects } from './components/Projects';
import { ScrollReveal } from './components/ScrollReveal';
import { Services } from './components/Services';
import { Skills } from './components/Skills';
import { Testimonials } from './components/Testimonials';
import { services } from './data/content';
import { initAnalytics } from './lib/firebase';
import type { PendingOrder, ServiceTier } from './types/portfolio';

export default function App() {
  const [selectedTier, setSelectedTier] = useState<ServiceTier>(services[0]);
  const [pendingOrder, setPendingOrder] = useState<PendingOrder | null>(null);

  useEffect(() => {
    void initAnalytics();
  }, []);

  return (
    <>
      <BackgroundEffects />
      <ScrollReveal />
      <Header />
      <main>
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Services selectedTier={selectedTier} onSelectTier={setSelectedTier} />
        <OrderForm selectedTier={selectedTier} onOrderReady={setPendingOrder} />
        <Checkout
          selectedTier={selectedTier}
          pendingOrder={pendingOrder}
          onSelectTier={setSelectedTier}
        />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
